/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {
  useEffect,
  useImperativeHandle,
  useState,
  forwardRef,
  useCallback,
} from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import type { Moment } from 'moment';
import moment from 'moment';
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { BULKCAMPAIGN_RESEND_DATE_MESSAGE, RESENDTOOPTIONS, SEND_TEST_EMAIL, BULK_UNSUBSCRIBE_LEVELS, PRIORITY_OPTIONS, BULK_CAMPAIGN_NAME_TOOLTIP_MESSAGE, BULK_CLIENT_CAMPAIGN_ID } from 'src/constants/constant';
import { getAlltemplate } from 'src/services/templateService';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import {  AddCircleStrokeRounded,  Delete02Icon,  ViewStrokeRounded,  Image03Icon,  ArrowDown01Icon,  MailSend02Icon,  HelpCircleIcon,Clock01Icon} from '@hugeicons-pro/core-stroke-rounded';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { IconButton } from '@mui/material';
import SendTestEmail from '../SendTestEmail/SendTestEmail';
import { useParams } from 'react-router-dom';
import { getBulkCampaignEndDate } from 'src/services/bulkEmailServices';
import type { RootState } from '../types/types';
import { useSelector } from 'react-redux';
import ReactGanttPopup from './GanttChart/BulkEmailGanttPopup';
import InputAdornment from '@mui/material/InputAdornment';

/** ---------- Types ---------- */
export interface EditBulkEmailCampaignInputs {
  templateId: string;
  unsubscribeTypeId?: string;
  priority: string;
  name: string;
  startDateTime: string; // ISO
  resendSchedules?: {
    id?: string;
    resendOrder: number;
    resendDateTime: string; // ISO
    resendType: string | number;
  }[];
  createdOn?: string;
  createdUser?: string;
  updatedOn?: string;
  updatedUser?: string;
  seedListName?: string;
  suppressionListName?: string;
  clientCampaignId?: string | null;
}

export interface EditBulkEmailFormRef {
  getFormData: () => Promise<EditBulkEmailCampaignInputs | null>;
  validateForm: () => Promise<boolean>;
}

interface Props {
  defaultValues?: Partial<EditBulkEmailCampaignInputs> & {
    resendSchedules?: {
      id?: string;
      resendOrder?: number;
      resendDateTime: string;
      resendType: number | string;
    }[];
  };
   bulkCampaignTotalCount: number;
}

interface TemplateItem {
  id: number;
  templateName: string;
  templateContent?: string;
  templateIdentifier?: string;
  templateVersion?: number;
}

interface ResendRow {
  id: string;
  dateTime: Moment | null;
  resendTo: string;
}

// New interface for resend validation errors
interface ResendValidationError {
  id: string;
  message: string | null;
}
/// date time picker ui 
const digitalClockSelectedStyle = {
  '&.Mui-selected': {
    backgroundColor: '#F13139 !important',
    color: 'white !important',
    fontWeight: '400',
    fontSize: '0.75rem',
    borderRadius: '10px',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#F13139 !important',
    borderRadius: '10px',
    fontWeight: '400',
    fontSize: '0.75rem',
  },
  '&.Mui-selected:focus': {
    backgroundColor: '#F13139 !important',
    color: 'white !important',
    borderRadius: '10px',
    fontWeight: '400',
    fontSize: '0.75rem',
  }
};
/** ---------- Validation ---------- */
const schema = Yup.object({
  name: Yup.string().required('Campaign name is required'),
  templateId: Yup.string().required('Email template is required'),
  startDateTime: Yup.string().required('Start date & time is required'),
  // unsubscribeTypeId: Yup.string().required("Please select unsubscribe level"),
  priority: Yup.string().required("Please select priority"),
  clientCampaignId: Yup.string()
    .max(100, 'Client Campaign ID cannot exceed 100 characters')
    .notRequired(),
});

/** ---------- Wrapper with FormProvider ---------- */
const EditBulkEmailFormWrapper = forwardRef<EditBulkEmailFormRef, Props>(
  function EditBulkEmailFormWrapper({ defaultValues,bulkCampaignTotalCount  }, ref) {
    const processedDefaultValues = {
      ...defaultValues,
      resendSchedules:
        defaultValues?.resendSchedules?.map((schedule, idx) => ({
          ...schedule,
          id: schedule.id ?? `default_resend_${idx}_${Date.now()}`,
        })) ?? [],
    };

    const methods = useForm<EditBulkEmailCampaignInputs>({
      resolver: yupResolver(schema),
      mode: 'onChange',
      defaultValues: {
        name: processedDefaultValues?.name ?? '',
        templateId: processedDefaultValues?.templateId ?? '',
        // unsubscribeTypeId: processedDefaultValues?.unsubscribeTypeId ?? '',
        priority: processedDefaultValues?.priority ?? '',
        startDateTime: processedDefaultValues?.startDateTime ?? '',
        resendSchedules: processedDefaultValues?.resendSchedules ?? [],
        clientCampaignId: processedDefaultValues?.clientCampaignId ?? '',
      },
      shouldUnregister: false,
    });

    return (
      <FormProvider {...methods}>
        <EditBulkEmailForm ref={ref} defaultValues={processedDefaultValues} bulkCampaignTotalCount={bulkCampaignTotalCount} />
      </FormProvider>
    );
  }
);

/** ---------- Inner Form ---------- */
const EditBulkEmailForm = forwardRef<EditBulkEmailFormRef, Props>(
  function InnerForm({ defaultValues,bulkCampaignTotalCount  }, ref): JSX.Element {
    const {
      control,
      getValues,
      trigger,
      setValue,
      watch,
      formState: { errors },
    } = useFormContext<EditBulkEmailCampaignInputs>();

    const [templates, setTemplates] = useState<TemplateItem[]>([]);
    const [selectedTemplate, setSelectedTemplate] =
      useState<TemplateItem | null>(null);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [estimatedEndDate, setEstimatedEndDate] =
      useState<any | null>(null);
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const [isFormInitialized, setIsFormInitialized] = useState(false);
    const [resendErrors, setResendErrors] = useState<ResendValidationError[]>([]);

    const formResendSchedules = watch('resendSchedules') ?? [];
    const watchedStartDateTime = watch('startDateTime');
    const watchedTemplateId = watch('templateId');
    const watchedPriority = watch('priority');
    const { user } = useSelector((state: RootState) => state.auth);
    
    const storedAppConfig = localStorage.getItem('appConfigs');
    const parsedAppConfig = storedAppConfig ? JSON.parse(storedAppConfig) : [];
    const TemplateImagePublicURL = parsedAppConfig.find(
      (item: any) => item.configName === 'TemplateImagePublicURL'
    )?.configValue;
    const ResendMaxValue: any = parsedAppConfig.find((item: any) => item.configType === "BulkCampaign" && item.configName === "ResendMaxValue")?.configValue;
    const [imageError, setImageError] = useState(false);
  const [campaignScheduleModal, setCampaignScheduleModal] = useState(false);
    const rows: ResendRow[] = formResendSchedules.map((schedule, idx) => ({
      id: schedule.id ?? `resend_${idx + 1}`,
      dateTime: schedule.resendDateTime
        ? moment(schedule.resendDateTime)
        : null,
      resendTo: String(schedule.resendType ?? '1'),
    }));

    // Resend validation function (same as AddNewBulkEmailForm)
  // Updated validateResendSchedules function - replace the existing one
const validateResendSchedules = useCallback((schedules: ResendRow[], startDate: string | null): boolean => {
  const errors: ResendValidationError[] = [];
  const usedDates = new Set<string>(); // Track used dates (without time)

  schedules.forEach((s) => {
    let error: string | null = null;

    if (!s.dateTime) {
      error = "Resend date is required";
    } else {
      const resendDate = moment(s.dateTime);
      
      // Check if resend date is same as or before start date (date only comparison)
      if (startDate) {
        const startDateMoment = moment(startDate);
        // Compare only dates, not time
        if (resendDate.format('YYYY-MM-DD') <= startDateMoment.format('YYYY-MM-DD')) {
          error = "Resend date must be later than the campaign start date.";
        }
      }
      
      // Check for duplicate dates (date only, ignore time)
      if (!error) {
        const dateOnly = resendDate.format('YYYY-MM-DD');
        if (usedDates.has(dateOnly)) {
          error = "Duplicate resend date is not allowed";
        } else {
          usedDates.add(dateOnly);
        }
      }
    }

    errors.push({ id: s.id, message: error });
  });

  setResendErrors(errors);
  return errors.every((e) => !e.message); // returns true if all are valid
}, []);

    /** Load templates */
    useEffect(() => {
      const loadTemplates = async (): Promise<void> => {
        try {
          const user = JSON.parse(localStorage.getItem('user') ?? '{}');
          const clientId = user?.clientId ?? 0;
          const res = await getAlltemplate(clientId);
          if (res?.status === 200 && Array.isArray(res?.data?.data)) {
            const templateArr = res.data.data
              .filter(
                (template: any) =>
                  template.statusName === 'Approved' && template.isDeleted !== 1
              )
              .map((template: any) => ({
                ...template,
                Name: template.templateName,
              }))
              // @ts-ignore
              .sort((a, b) => a.Name.localeCompare(b.Name));
            setTemplates(templateArr);
          } else {
            setTemplates([]);
          }
        } catch (error) {
          console.error('Error loading templates:', error);
          setTemplates([]);
        }
      };
      void loadTemplates();
    }, []);

    /** Initialize resendSchedules */
    useEffect(() => {
      if (!isFormInitialized && defaultValues?.resendSchedules?.length) {
        const initialSchedules = defaultValues.resendSchedules.map(
          (r, idx) => ({
            id: r.id ?? `resend_${idx + 1}_${Date.now()}`,
            resendOrder: r.resendOrder ?? idx + 1,
            resendDateTime: r.resendDateTime ?? '',
            resendType: r.resendType ?? '1',
          })
        );
        setValue('resendSchedules', initialSchedules);
        setIsFormInitialized(true);
      } else if (!isFormInitialized) {
        setIsFormInitialized(true);
      }
    }, [defaultValues, setValue, isFormInitialized]);

    /** Update selected template */
    useEffect(() => {
      if (watchedTemplateId && templates.length > 0) {
        const template = templates.find(
          (t) => String(t.id) === String(watchedTemplateId)
        );
        setSelectedTemplate(template ?? null);
      }
    }, [watchedTemplateId, templates]);

    useEffect(() => {
      setImageError(false);
    }, [selectedTemplate?.templateIdentifier]);

    // Validate resend schedules when they change or start date changes
    useEffect(() => {
      if (rows.length > 0) {
        validateResendSchedules(rows, watchedStartDateTime ?? null);
      } else {
        setResendErrors([]);
      }
    }, [rows, watchedStartDateTime, validateResendSchedules]);

    /** Expose methods */
    useImperativeHandle(ref, () => ({
      async getFormData() {
        const valid = await trigger();
        const areResendsValid = validateResendSchedules(rows, watchedStartDateTime ?? null);
        
        if (!valid || !areResendsValid) return null;

        const values = getValues();

        // Only keep resend schedules that have a valid dateTime
        const formattedResendSchedules =
          (values.resendSchedules ?? [])
            .filter((s) => s.resendDateTime) // ignore rows without a datetime
            .map((s, idx) => ({
              id: s.id,
              resendOrder: idx + 1,
              resendDateTime: s.resendDateTime,
              resendType: s.resendType,
            }));

        return {
          ...values,
          templateName: selectedTemplate?.templateName ?? '',
          templateIdentifier: selectedTemplate?.templateIdentifier ?? '',
          templateVersion: selectedTemplate?.templateVersion ?? 0,
          templateContent: selectedTemplate?.templateContent ?? '',
          campaignStartDate: values.startDateTime,
          estimatedEndDate: estimatedEndDate
          ? estimatedEndDate.format('YYYY-MM-DDTHH:mm:ss')
          : '',
          resendSchedules: formattedResendSchedules,
          resendMaxLimit: formattedResendSchedules.length,
        };
      },
      async validateForm() {
        const isFormValid = await trigger();
        const areResendsValid = validateResendSchedules(rows, watchedStartDateTime ?? null);
        return isFormValid && areResendsValid;
      },
    }));

    /** Helpers */
    const addRow = useCallback((): void => {
      const currentSchedules = getValues('resendSchedules') ?? [];
      if (currentSchedules.length >= ResendMaxValue) return;
      const newSchedule = {
        id: `resend_${Date.now()}`,
        resendOrder: currentSchedules.length + 1,
        resendDateTime: '',
        resendType: String(RESENDTOOPTIONS[0]?.value ?? '1'),
      };
      setValue('resendSchedules', [...currentSchedules, newSchedule]);
    }, [getValues, setValue, ResendMaxValue]);

    const removeRow = useCallback(
      (id: string): void => {
        const currentSchedules = getValues('resendSchedules') ?? [];
        const updatedSchedules = currentSchedules
          .filter((schedule: any) => schedule.id !== id)
          .map((s: any, idx: number) => ({
            ...s,
            resendOrder: idx + 1,
          }));
        setValue('resendSchedules', updatedSchedules, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
      },
      [getValues, setValue]
    );
   const updateRow = useCallback(
  (id: string, field: keyof ResendRow, value: Moment | string | null) => {
    const currentSchedules = getValues('resendSchedules') ?? [];
    const updatedSchedules = currentSchedules.map((schedule: any) => {
      if (schedule.id === id) {
        if (field === 'dateTime') {
          return {
            ...schedule,
            resendDateTime: value && moment.isMoment(value)
              ? formatDateTimePreservingLocal(value)
              : '',
          };
        } else if (field === 'resendTo') {
          return { ...schedule, resendType: value as string };
        }
      }
      return schedule;
    });
    
    setValue('resendSchedules', updatedSchedules, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    
    // Run validation immediately after update
    const updatedRows = updatedSchedules.map((schedule: any, idx: number) => ({
      id: schedule.id ?? `resend_${idx + 1}`,
      dateTime: schedule.resendDateTime ? moment(schedule.resendDateTime) : null,
      resendTo: String(schedule.resendType ?? '1'),
    }));
    validateResendSchedules(updatedRows, watchedStartDateTime ?? null);
  },
  [getValues, setValue, validateResendSchedules, watchedStartDateTime]
);
    // const updateRow = useCallback(
    //   (id: string, field: keyof ResendRow, value: Moment | string | null) => {
    //     const currentSchedules = getValues('resendSchedules') ?? [];
    //     const updatedSchedules = currentSchedules.map((schedule: any) => {
    //       if (schedule.id === id) {
    //         if (field === 'dateTime') {
    //           return {
    //             ...schedule,
    //             resendDateTime: value
    //               ? (value as Moment).toISOString()
    //               : '',
    //           };
    //         } else if (field === 'resendTo') {
    //           return { ...schedule, resendType: value as string };
    //         }
    //       }
    //       return schedule;
    //     });
    //     setValue('resendSchedules', updatedSchedules, {
    //       shouldDirty: true,
    //       shouldTouch: true,
    //       shouldValidate: true,
    //     });
        
    //     // Run validation immediately after update
    //     const updatedRows = updatedSchedules.map((schedule: any, idx: number) => ({
    //       id: schedule.id ?? `resend_${idx + 1}`,
    //       dateTime: schedule.resendDateTime ? moment(schedule.resendDateTime) : null,
    //       resendTo: String(schedule.resendType ?? '1'),
    //     }));
    //     validateResendSchedules(updatedRows, watchedStartDateTime ?? null);
    //   },
    //   [getValues, setValue, validateResendSchedules, watchedStartDateTime]
    // );

    const { id } = useParams();
    const calculateEstimateEndDate = useCallback(
      (startDateTime: any, totalCount: number, priority: string) => {
        if (!startDateTime || !user?.clientId || !totalCount || !priority) {
          setEstimatedEndDate(null);
          return;
        }

        const startDateTimeFORMAT = moment(startDateTime).format("YYYY-MM-DD[T]HH:mm:ss");
        const data = {
          clientId: user.clientId,
          startDateTime: startDateTimeFORMAT,
          recordsCount: totalCount,
          priority: parseInt(priority) || 1,
          campaignId: id,
          espConnectionId: user.espConnectionId
        };
        //@ts-ignore
        getBulkCampaignEndDate(data)
          .then((res: any) => {
            if (res.status === 200 && Array.isArray(res.data?.data)) {
              const targetCampaign = res.data.data.find((c: any) => c.campaignId === -1);
              if (targetCampaign?.endDateTime) {
                setEstimatedEndDate(moment(targetCampaign.endDateTime));
              } else {
                setEstimatedEndDate(null);
              }
            }
          })
          .catch(() => setEstimatedEndDate(null));
      },
      [user?.clientId, user?.espConnectionId, id]
    );
// Only call API during initial loading - replace the commented useEffect with this:
useEffect(() => {
  // Call API only during initial load if all required values are present from defaultValues
  if (isFormInitialized && 
      defaultValues?.startDateTime && 
      bulkCampaignTotalCount > 0 && 
      defaultValues?.priority) {
    calculateEstimateEndDate(
      defaultValues.startDateTime, 
      bulkCampaignTotalCount, 
      defaultValues.priority
    );
  }
}, [isFormInitialized, defaultValues?.startDateTime, defaultValues?.priority, bulkCampaignTotalCount, calculateEstimateEndDate]);

// Note: The onAccept handler in the DateTimePicker already handles API calls when user changes the date
    // useEffect(() => {
    //   if (watchedStartDateTime && bulkCampaignTotalCount > 0 && watchedPriority) {
    //     calculateEstimateEndDate(watchedStartDateTime, bulkCampaignTotalCount, watchedPriority);
    //   } else {
    //     setEstimatedEndDate(null);
    //   }
    // }, [watchedStartDateTime, bulkCampaignTotalCount, watchedPriority, calculateEstimateEndDate]);
   const handleCampaignSchedule = () : void=> {
        setCampaignScheduleModal(true);
        // navigate('/bulk-email/schedule');
      }
      const formatDateTimePreservingLocal = (momentDate: Moment | null): string => {
  if (!momentDate) return '';
  
  // Format the date to preserve local time without timezone conversion
  return momentDate.format('YYYY-MM-DDTHH:mm:ss');
};

// ✅ Trigger API when priority changes, but only if startDateTime already confirmed
useEffect(() => {
  if (watchedPriority && watchedStartDateTime && bulkCampaignTotalCount > 0) {
    calculateEstimateEndDate(
      watchedStartDateTime,
      bulkCampaignTotalCount,
      watchedPriority
    );
  }
}, [watchedPriority, bulkCampaignTotalCount, calculateEstimateEndDate]);

    return (
      <div className="flex flex-row justify-start">
        <div className="flex justify-between items-center w-full">
          <Grid container spacing={2}>
            {/* Left side form */}
            <Grid item xs={8} sx={{ paddingRight: '20px' }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <div className="pt-[20px]">
                  <form>
                    {/* Campaign Name */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="mb-[30px]">
                          <Controller
                            name="name"
                            control={control}
                            render={({ field }) => (
                              <>
                                <TextField
                                  {...field}
                                  fullWidth
                                  autoComplete="off"
                                  label="Campaign Name*"
                                  error={Boolean(errors.name)}
                                  InputProps={{
                                      endAdornment: (
                                          <CustomTooltip title={BULK_CAMPAIGN_NAME_TOOLTIP_MESSAGE} placement="top" arrow>
                                              <InputAdornment position="end" >

                                                  <HugeiconsIcon
                                                      icon={HelpCircleIcon}
                                                      size={18}
                                                      color="#3A3A3A"
                                                      strokeWidth={0.2}
                                                  />

                                              </InputAdornment>
                                          </CustomTooltip >
                                      ),
                                  }}
                                />
                                {errors.name && (
                                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img
                                      src="/assets/images/attention.svg"
                                      alt="name"
                                      width={12}
                                      height={12}
                                      className="mr-1"
                                    />
                                    {errors.name?.message}
                                  </div>
                                )}
                              </>
                            )}
                          />
                        </div>
                      </Grid>
                    </Grid>

                    {/* Template */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="mb-[30px]">
                          <Controller
                            name="templateId"
                            control={control}
                            render={({ field }) => {
                              const selected =
                                templates.find(
                                  (t) => String(t.id) === String(field.value)
                                ) ?? null;
                              return (
                                <>
                                  <Autocomplete
                                    options={templates}
                                    //@ts-ignore
                                    value={selected}
                                    getOptionLabel={(option) =>
                                      option.templateName
                                    }
                                    disableClearable
                                    popupIcon={
                                      <HugeiconsIcon
                                        icon={ArrowDown01Icon}
                                        size={18}
                                        color="#3A3A3A"
                                        strokeWidth={0.2}
                                      />
                                    }
                                    onChange={(_, value) => {
                                      const newTemplateId = value
                                        ? String(value.id)
                                        : '';
                                      field.onChange(newTemplateId);
                                      setSelectedTemplate(value ?? null);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Email Template*"
                                        error={Boolean(errors.templateId)}
                                      />
                                    )}
                                  />
                                  {errors.templateId && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                      <img
                                        src="/assets/images/attention.svg"
                                        alt="template"
                                        width={12}
                                        height={12}
                                        className="mr-1"
                                      />
                                      {errors.templateId?.message}
                                    </div>
                                  )}
                                </>
                              );
                            }}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    {/* Unsubscribe Level */}
                    {/* <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className="mb-[30px]">
                            <Controller
                                name="unsubscribeTypeId"
                                control={control}
                                render={({ field }) => {
                                  const selected =
                                    BULK_UNSUBSCRIBE_LEVELS.find(
                                      (level) => String(level.value) === String(field.value)
                                    ) ?? undefined;

                                  return (
                                    <Autocomplete
                                      options={BULK_UNSUBSCRIBE_LEVELS}
                                      value={selected}
                                      getOptionLabel={(option) => option.label}
                                      disableClearable
                                      popupIcon={
                                        <HugeiconsIcon
                                          icon={ArrowDown01Icon}
                                          size={18}
                                          color="#3A3A3A"
                                          strokeWidth={0.2}
                                        />
                                      }
                                      onChange={(_, value) => {
                                        field.onChange(value ? value.value : "");
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Unsubscribe Level*"
                                          error={Boolean(errors.unsubscribeTypeId)}
                                        />
                                      )}
                                    />
                                  );
                                }}
                              />
                              {errors.unsubscribeTypeId && (
                                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="template" width={12} height={12} className="mr-1" />
                                    {errors.unsubscribeTypeId?.message}
                                  </div>
                              )}
                            </div>
                        </Grid>
                    </Grid> */}
                    {/* Priority */}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className="mb-[30px]">
                            <Controller
                                name="priority"
                                control={control}
                                render={({ field }) => {
                                  const selected =
                                    PRIORITY_OPTIONS.find(
                                      (level) => String(level.value) === String(field.value)
                                    ) ?? undefined;

                                  return (
                                    <Autocomplete
                                      options={PRIORITY_OPTIONS}
                                      value={selected}
                                      getOptionLabel={(option) => option.label}
                                      disableClearable
                                      popupIcon={
                                        <HugeiconsIcon
                                          icon={ArrowDown01Icon}
                                          size={18}
                                          color="#3A3A3A"
                                          strokeWidth={0.2}
                                        />
                                      }
                                      onChange={(_, value) => {
                                        field.onChange(value ? value.value : "");
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Priority*"
                                          error={Boolean(errors.priority)}
                                        />
                                      )}
                                    />
                                  );
                                }}
                              />
                              {errors.priority && (
                                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="template" width={12} height={12} className="mr-1" />
                                    {errors.priority?.message}
                                  </div>
                              )}
                            </div>
                        </Grid>
                    </Grid>
                    {/* Client Campaign ID */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <div className="mb-[30px]">
                          <Controller
                            name="clientCampaignId"
                            control={control}
                            render={({ field }) => (
                              <>
                                <TextField
                                  {...field}
                                  fullWidth
                                  autoComplete="off"
                                  label="Client Campaign ID"
                                  error={Boolean(errors.clientCampaignId)}
                                  InputProps={{
                                    endAdornment: (
                                      <CustomTooltip title={BULK_CLIENT_CAMPAIGN_ID} placement="top" arrow>
                                        <InputAdornment position="end">
                                          <HugeiconsIcon
                                            icon={HelpCircleIcon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}
                                          />
                                        </InputAdornment>
                                      </CustomTooltip>
                                    ),
                                  }}
                                />
                                {errors.clientCampaignId && (
                                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img
                                      src="/assets/images/attention.svg"
                                      alt="clientCampaignId"
                                      width={12}
                                      height={12}
                                      className="mr-1"
                                    />
                                    {errors.clientCampaignId?.message}
                                  </div>
                                )}
                              </>
                            )}
                          />
                        </div>
                      </Grid>
                    </Grid>
                    {/* Start & End Dates */}
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <div className="mb-[30px]">
                         <Controller
  name="startDateTime"
  control={control}
  render={({ field }) => (
    <>
      <DateTimePicker
        label="Campaign Start Date Time*"
        disablePast
        value={field.value ? moment(field.value) : null}
         closeOnSelect={false} 
        onChange={(newValue) => {
          // Only update if we have a valid moment object
          if (newValue && moment.isMoment(newValue)) {
            const formattedValue = formatDateTimePreservingLocal(newValue);
            field.onChange(formattedValue);
          } else if (newValue === null) {
            field.onChange('');
          }
        }}
        onAccept={(acceptedValue) => {
        if (acceptedValue && moment.isMoment(acceptedValue)) {
          const formattedValue = formatDateTimePreservingLocal(acceptedValue);
          field.onChange(formattedValue);

          // 👉 Trigger API only when OK button is pressed
          if (bulkCampaignTotalCount > 0 && watchedPriority) {
            calculateEstimateEndDate(formattedValue, bulkCampaignTotalCount, watchedPriority);
          }
        }
      }}
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(errors.startDateTime),
          },
          digitalClockSectionItem: {
            sx: digitalClockSelectedStyle
          }             
        }}
      />
      {errors.startDateTime && (
        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
          <img
            src="/assets/images/attention.svg"
            alt="date"
            width={12}
            height={12}
            className="mr-1"
          />
          {errors.startDateTime?.message}
        </div>
      )}
    </>
  )}
/>
                        </div>
                      </Grid>
                       
                  <Grid item xs={6}>
  <div className="mb-[30px] flex items-center justify-between">
    {/* Label + Value */}
    <div className="flex items-center gap-2 w-3/4">
      <span className="text-muted font-bold text-[14px]">
        End Date:
      </span>
      <span className="text-muted font-normal text-[14px]">
        {estimatedEndDate ? new Date(estimatedEndDate)
                              .toLocaleString("en-US", {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true,
                              })
                              .replace(",", "") : 'N/A'}
      </span>
    </div>

    {/* Clock Icon */}
    <div
      className="cursor-pointer flex items-center justify-center rounded-full hover:bg-gray-100 p-1"
      onClick={handleCampaignSchedule}
    >
      <HugeiconsIcon
        icon={Clock01Icon}
        size={18}
        color="#3A3A3A"
        strokeWidth={0.2}
      />
    </div>
  </div>
</Grid>

                    </Grid>

                    {/* Resend schedules */}
                    {rows.map((r, idx) => {
                      const errorObj = resendErrors.find((e) => e.id === r.id);
                      return (
                        <div key={r.id} className="pb-4 mb-2">
                          <Grid container spacing={2} alignItems="flex-start">
                            <Grid item xs={6}>
                              <DateTimePicker
                                label={`Resend ${idx + 1} Date Time*`}
                                value={r.dateTime}
                                closeOnSelect={false} 
                                onChange={(newValue) => {
                                  // Only update if we have a valid moment object or null
                                  if (newValue && moment.isMoment(newValue)) {
                                    updateRow(r.id, 'dateTime', newValue);
                                  } else if (newValue === null) {
                                    updateRow(r.id, 'dateTime', null);
                                  }
                                }}
                                disablePast
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !r.dateTime || !!errorObj?.message,
                                  },
                                  digitalClockSectionItem: {
                                    sx: digitalClockSelectedStyle
                                  }    
                                }}
                              />



                              {errorObj?.message && (
                                <div className="flex text-primary ml-1 mt-1 text-md font-normal">
                                  <img src="/assets/images/attention.svg" alt="error" width={12} height={12} className="mr-1" />
                                  {errorObj.message}
                                </div>
                              )}
                            </Grid>
                            <Grid item xs={5}>
                              <FormControl fullWidth>
                                <Autocomplete
                                  options={RESENDTOOPTIONS}
                                  value={RESENDTOOPTIONS.find(
                                    (opt) =>
                                      String(opt.value) === String(r.resendTo)
                                  )}
                                  getOptionLabel={(option) => option.label}
                                  disableClearable
                                  popupIcon={
                                    <HugeiconsIcon
                                      icon={ArrowDown01Icon}
                                      size={18}
                                      color="#3A3A3A"
                                      strokeWidth={0.2}
                                    />
                                  }
                                  onChange={(_, value) => {
                                    if (value) {
                                      updateRow(
                                        r.id,
                                        'resendTo',
                                        String(value.value)
                                      );
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Resend To" />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid
                              item
                              xs={1}
                              className="flex items-center justify-center"
                            >
                              <div
                                className="cursor-pointer flex items-center justify-center w-10 h-10 rounded-full hover:bg-red-50"
                                onClick={() => removeRow(r.id)}
                              >
                                <HugeiconsIcon
                                  icon={Delete02Icon}
                                  size={18}
                                  color="#dc2626"
                                  strokeWidth={0.2}
                                />
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      );
                    })}

                    {rows.length < ResendMaxValue && (
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <div
                            className="flex items-center justify-center mb-[20px] cursor-pointer"
                            onClick={addRow}
                          >
                            <HugeiconsIcon
                              icon={AddCircleStrokeRounded}
                              size={18}
                              color="#3a3a3a"
                              strokeWidth={0.2}
                              className="mr-2"
                            />
                            <span className="flex items-center font-medium text-[#3a3a3a]">
                              <span style={{ textDecoration: 'underline' }}>
                                Add resend schedule
                              </span>
                              <span className="ml-1 italic text-gray-500 text-sm">
                                (optional)
                              </span>
                            </span>
                            <CustomTooltip
                              title={BULKCAMPAIGN_RESEND_DATE_MESSAGE}
                              placement="top"
                              arrow
                            >
                              <span className="ml-2 flex items-center">
                                <HugeiconsIcon
                                  icon={HelpCircleIcon}
                                  size={18}
                                  color="#3a3a3a"
                                  strokeWidth={0.2}
                                />
                              </span>
                            </CustomTooltip>
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </form>
                </div>
              </LocalizationProvider>
            </Grid>

            {/* Right Section - Template Preview */}
            <Grid item xs={4} sx={{ paddingLeft: '20px' }}>
              <div className="flex justify-between mb-[5px]">
                <div className="text-16 font-semibold text-muted">Template Preview</div>
                <div className="icon-hover-container">
                  <CustomTooltip
                    title={SEND_TEST_EMAIL}
                    placement="bottom"
                    arrow={false}
                  >
                    <IconButton onClick={() => setTestEmailModalOpen(true)}>
                      <HugeiconsIcon
                        icon={MailSend02Icon}
                        size={18}
                        strokeWidth={0.2}
                        color="#3a3a3a"
                      />
                    </IconButton>
                  </CustomTooltip>
                </div>
              </div>

              <div className="relative flex justify-center items-center h-[375px] border border-[#e6ecf2] rounded-lg overflow-hidden">               
                 {selectedTemplate?.templateIdentifier ? (
                  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
                    {!imageError ? (
                      <img
                        src={`${TemplateImagePublicURL}Template/${selectedTemplate.templateIdentifier}/${selectedTemplate.templateVersion}/Template_Large.png`}
                        alt="Template Preview"
                        className="w-full h-full object-cover rounded-lg"
                        onError={() => setImageError(true)}
                      />
                    ) : (
                      <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                    )}
                  </div>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-lg">
                    <HugeiconsIcon icon={Image03Icon} size={50} color="#6B7280" />
                  </div>
                )}

                {/* Hover overlay */}
                <div
                  className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${
                    selectedTemplate?.templateIdentifier
                      ? 'hover:opacity-100 transition-opacity cursor-pointer'
                      : ''
                  }`}
                  onClick={
                    selectedTemplate?.templateContent
                      ? () => setIsPreviewOpen(true)
                      : undefined
                  }
                >
                  <HugeiconsIcon
                    icon={ViewStrokeRounded}
                    size={24}
                    color="currentcolor"
                    strokeWidth={0.5}
                    className={`cursor-pointer text-white ${
                      !selectedTemplate?.templateContent
                        ? 'opacity-50 cursor-not-allowed'
                        : ''
                    }`}
                  />
                </div>
              </div>
              {/* Template metadata */}
              {(defaultValues?.createdOn || defaultValues?.createdUser || defaultValues?.updatedOn || defaultValues?.updatedUser) && (
                <div className="mt-3 text-[14px] text-gray-700 space-y-1">
                  {(defaultValues?.createdOn || defaultValues?.createdUser) && (
                    <div>
                      <span className="font-semibold text-muted">Created:</span>{" "}
                      {defaultValues?.createdOn && moment(defaultValues.createdOn).format("MM/DD/YYYY h:mmA")}
                      {defaultValues?.createdUser && (
                        <span className="italic text-gray-600"> ({defaultValues.createdUser})</span>
                      )}
                    </div>
                  )}
                  {(defaultValues?.updatedOn || defaultValues?.updatedUser) && (
                    <div>
                      <span className="font-semibold text-muted">Last Updated:</span>{" "}
                      {defaultValues?.updatedOn && moment(defaultValues.updatedOn).format("MM/DD/YYYY h:mmA")}
                      {defaultValues?.updatedUser && (
                        <span className="italic text-gray-600"> ({defaultValues.updatedUser})</span>
                      )}
                    </div>
                  )}
                </div>
              )}
              <TemplatePreview
                isOpen={isPreviewOpen}
                onClose={() => setIsPreviewOpen(false)}
                content={selectedTemplate?.templateContent ?? ''}
              />
            </Grid>
          </Grid>
        </div>

        {/* Send Test Email Modal */}
        <SendTestEmail
          open={testEmailModalOpen}
          onClose={() => setTestEmailModalOpen(false)}
          Type={'BulkCampaign'}
          TypeId={id as unknown as number}
          TemplateId={selectedTemplate?.id ?? 0}
        />
        {/* Campaign gantt chart Modal */}
        <ReactGanttPopup
                open={campaignScheduleModal}
                onClose={() => setCampaignScheduleModal(false)}
              />

      </div>
    );
  }
);

export default EditBulkEmailFormWrapper;
export type { Props as EditBulkEmailFormProps };